// extracted by mini-css-extract-plugin
export default {"scrollButton":"ScrollButton_scrollButton__ZTFV2","arrowUp":"ScrollButton_arrowUp__ielri","inactive":"ScrollButton_inactive__CXETy"};